import React, { FC, useState } from 'react';
import styled from 'styled-components';
import ChangeBonusForm from './ChangeBonusForm';
import { useSelector } from 'react-redux';
import { StyledTemplate } from './StyledTemplate';
import { cardSelect } from '@entities/card';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';
import EditCardModal from '@pages/crm/components/content/EditCardModal';
import { Icons } from '@assets';

interface PropsClientModal {
    setOpeningSettingsPopup: (val: boolean) => void;
}

const ContentModalCards: FC<PropsClientModal> = ({
    setOpeningSettingsPopup,
}) => {
    const [showFormBonus, setShowFormBonus] = useState<boolean>(false);
    const [showEditCardModal, setShowEditCardModal] = useState<boolean>(false);
    const [cardFormBonus, setCardFormBonus] = useState<number>(0);
    const [cardEdit, setCardEdit] = useState<number>(0);

    const { clientCards } = useSelector(cardSelect);

    const toggleFormBonus = (id: number) => {
        setShowFormBonus(!showFormBonus);
        setCardFormBonus(id);
    };
    const handleCardEditModal = (id: number) => {
        setShowEditCardModal(!showEditCardModal);
        setCardEdit(id);
    };

    return (
        <Wrapper>
            <Hr />
            <StyledTableWrapper>
                <StyledTableHeader>
                    <HeaderTitle style={{ width: '30px', paddingLeft: '5px' }}>
                        ID
                    </HeaderTitle>
                    <HeaderTitle style={{ width: '50px' }}>Статус</HeaderTitle>
                    <HeaderTitle style={{ width: '100px' }}>Код</HeaderTitle>
                    <HeaderTitle style={{ width: '120px' }}>Тип</HeaderTitle>
                    <HeaderTitle style={{ width: '140px' }}>
                        Депозит
                    </HeaderTitle>
                    <HeaderTitle style={{ width: '130px' }}>Бонусы</HeaderTitle>
                </StyledTableHeader>
                <Br />
                <StyledTableBody>
                    {clientCards?.map((item, ind) => (
                        <React.Fragment key={`fragment1-${ind}`}>
                            <InfoWrap key={`infowrap1-${ind}`}>
                                <InfoCardNum key={`infocard1-${ind}`}>
                                    {item.id}
                                </InfoCardNum>
                                <InfoCardStatus>
                                    {!item.isLocked ? (
                                        <span title="Карта активна">
                                            <img
                                                src={Icons.CircleCheck}
                                                alt="icon search"
                                            />
                                        </span>
                                    ) : (
                                        <span title="Карта заблокирована">
                                            <img
                                                src={Icons.CircleQuestion}
                                                alt="icon question"
                                            />
                                        </span>
                                    )}
                                </InfoCardStatus>
                                <InfoCardCode key={`infocardCode1-${ind}`}>
                                    {item?.code}
                                </InfoCardCode>
                                <InfoCardName key={`infoCardName1-${ind}`}>
                                    <StyledTemplate
                                        template={item?.template}
                                        ind={ind}
                                    />
                                </InfoCardName>

                                <InfoSumm key={`infosumbalance-${ind}`}>
                                    {item.balance
                                        ? new Intl.NumberFormat('ru-RU', {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                          }).format(Number(item.balance))
                                        : '0,00'}
                                </InfoSumm>

                                {showFormBonus && item.id === cardFormBonus && (
                                    <ChangeBonusForm
                                        card={item}
                                        setShowFormBonus={setShowFormBonus}
                                    />
                                )}
                                {showEditCardModal && item.id === cardEdit && (
                                    <EditCardModal
                                        card={item}
                                        setShowEditCardModal={
                                            setShowEditCardModal
                                        }
                                    />
                                )}

                                <InfoBalance
                                    key={`infosumbonus-${ind}`}
                                    onClick={() => toggleFormBonus(item.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {item.bonus
                                        ? new Intl.NumberFormat('ru-RU', {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                          }).format(Number(item.bonus))
                                        : '0,00'}
                                </InfoBalance>
                                <StyledEditButton
                                    onClick={() => handleCardEditModal(item.id)}
                                >
                                    <img src={Icons.MoreIcon} alt="icon more" />
                                </StyledEditButton>
                            </InfoWrap>
                            <Br />
                        </React.Fragment>
                    ))}
                </StyledTableBody>
            </StyledTableWrapper>
            <StyledFooter>
                <StyledButtonClose
                    onClick={() => setOpeningSettingsPopup(false)}
                >
                    Закрыть
                </StyledButtonClose>
                <StyledButtonSave
                    onClick={() => setOpeningSettingsPopup(false)}
                >
                    <span>Сохранить</span>
                </StyledButtonSave>
            </StyledFooter>
        </Wrapper>
    );
};

export default ContentModalCards;

const StyledEditButton = styled.button`
    background: transparent;
    border: none;
    outline: none;
    padding: 5px;
    margin: 0;
    cursor: pointer;
`;

const CommonTd = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 15px;
    width: 100%;
    ${flexMixin('row', 'flex-start', 'center')};
    color: ${colors.grey};
`;

const StyledTableWrapper = styled.div`
    height: 643px;
`;

const StyledTableHeader = styled.div`
    ${flexMixin('row', 'space-between', 'center')}
    width: 100%;
    height: 46px;
`;

const HeaderTitle = styled.div`
    height: 23px;
    text-align: center;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 700,
    })};
    line-height: 23px;
    ${flexMixin('row', 'flex-start', 'center')}
    color: ${colors.grey};
`;

const StyledTableBody = styled.div`
    display: flex;
    flex-direction: column;
    ${flexMixin('column', 'center', 'center')}
    max-height: 470px;
    overflow-y: auto;
    overflow-x: hidden;
`;

const InfoCardStatus = styled(CommonTd)`
    max-width: 50px;
    padding-left: 5px;
`;

const InfoCardNum = styled(CommonTd)`
    max-width: 30px;
    padding-left: 5px;
    text-align: left;
`;
const InfoCardCode = styled(CommonTd)`
    max-width: 100px;
    padding-left: 8px;
`;

const InfoCardName = styled(CommonTd)`
    width: 120px;
    color: #a7388e;
    padding-left: 8px;
`;

const InfoSumm = styled(CommonTd)`
    width: 140px;
    padding-left: 15px;
`;

const InfoBalance = styled(CommonTd)`
    width: 120px;
    padding-left: 20px;
`;

const InfoWrap = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')}
    height: 46px;
`;

const StyledButtonClose = styled.div`
    width: 59px;
    height: 28px;
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    line-height: 28px;
    ${flexMixin('column', 'center', 'center')}
    color: #8f8f8f;
    cursor: pointer;
`;

const StyledButtonSave = styled.div`
    ${flexMixin('row', 'center', 'center')}
    padding: 6px 58px;
    gap: 10px;
    cursor: pointer;
    width: 195px;
    height: 40px;
    background: #a7388e;
    border-radius: 5px;

    flex: none;
    order: 1;
    flex-grow: 0;

    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        align-items: center;
        text-align: center;
        color: #ffffff;
    }
`;

const StyledFooter = styled.div`
    gap: 34px;
    ${flexMixin('row', 'flex-end', 'center')}
    height: 40px;
    margin-top: 11px;
    position: absolute;
    bottom: 10px;
    right: 10px;
`;

const Hr = styled.hr`
    width: 675px;
    height: 0;
    margin-bottom: 15px;
    border: 3px solid rgba(143, 143, 143, 0.3);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
`;

const Br = styled.hr`
    margin: 5px 0;
    width: 675px;
    height: 0;
    border: 1px solid rgba(143, 143, 143, 0.3);
`;

const Wrapper = styled.div`
    ${flexMixin('column', 'center', 'center')}
    width: 675px;
    height: 524px;
    z-index: 1205;
    flex: none;
    flex-grow: 0;
`;
